import { FC } from 'react';
import { GeneralSettingsFormProvider } from './GeneralSettingsPage.form.context';
import { GeneralSettingsDataProvider } from './GeneralSettingsPage.data.context';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';
import { useSelector } from 'react-redux';
import { GeneralSettingsTabReadView } from './GeneralSettingsPage.read';
import { GeneralSettingsTabEditView } from './GeneralSettingsPage.edit';
import { useLocation } from 'react-router-dom';

export const GeneralSettingsFormTab: FC = () => {
  const isUserSecondary = useSelector(isUserSecondarySelector);
  const location = useLocation();
  const isEditMode = location.pathname.includes('/edit');

  if (isUserSecondary || !isEditMode) {
    return <GeneralSettingsTabReadView />;
  }

  return (
    <GeneralSettingsFormProvider>
      <GeneralSettingsTabEditView />
    </GeneralSettingsFormProvider>
  );
};

export const GeneralSettingsPage: FC = () => {
  return (
    <GeneralSettingsDataProvider>
      <GeneralSettingsFormTab />
    </GeneralSettingsDataProvider>
  );
};
